
<template>
    <div>
        <el-card class="box-card" style="width: 26rem; height: 100%" v-drag>
            <div slot="header">
                <span style="font-weight: 600">{{ checkPopInfo.name }}</span>
            </div>
            <div
                style="
                    text-align: left;
                    margin-top: 0.6rem;
                    margin-left: 1.6rem;
                    margin-right: 1.6rem;
                    margin-bottom: 0.6rem;
                "
            >
                <el-row>
                    <el-col :span="6" style="text-align: right">
                        <strong>聚落简介：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{
                            checkPopInfo.excursus == null
                                ? '暂无介绍'
                                : checkPopInfo.excursus
                        }}</span></el-col
                    >
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>今地名：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{
                            checkPopInfo.n_position == null
                                ? '暂无介绍'
                                : checkPopInfo.n_position
                        }}</span></el-col
                    >
                </el-row>

                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>定位依据：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{
                            checkPopInfo.input_reas == null
                                ? '暂无介绍'
                                : checkPopInfo.input_reas
                        }}</span></el-col
                    >
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>定位人员：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{
                            checkPopInfo.user == null
                                ? '暂无介绍'
                                : checkPopInfo.user
                        }}</span></el-col
                    >
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>真实姓名：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{
                            checkPopInfo.other == null
                                ? '暂无介绍'
                                : checkPopInfo.other
                        }}</span></el-col
                    >
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>定位单位：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{
                            checkPopInfo.input_work == null
                                ? '暂无介绍'
                                : checkPopInfo.input_work
                        }}</span></el-col
                    >
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>定位时间：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{
                            checkPopInfo.input_time == null
                                ? '暂无介绍'
                                : checkPopInfo.input_time
                        }}</span></el-col
                    >
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :offset="6">
                        <span>
                            <el-radio-group v-model="isPassFlag">
                                <el-radio :label="1">通过</el-radio>
                                <el-radio :label="2">不通过</el-radio>
                            </el-radio-group>
                        </span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong style="line-height: 2rem">审核理由：</strong>
                    </el-col>
                    <el-col :span="18">
                        <span>
                            <el-input
                                type="textarea"
                                style="width: 100%"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="check_reas"
                            >
                            </el-input>
                        </span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px">
                    <el-col :offset="6">
                        <el-button @click="checkFinish()">确定</el-button>
                        <el-button
                            @click="closeCheck()"
                            style="margin-left: 60px"
                            >取消</el-button
                        >
                    </el-col>
                </el-row>
            </div>
        </el-card>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            isPassFlag: 1,
            check_reas: '',
        }
    },
    watch: {

    },
    props: {
        checkPopInfo: Object,
    },
    mounted() {},
    computed: {},
    methods: {
        
        closeCheck() {
            this.$emit('cancleCheck')
        },
        checkFinish() {
            this.$emit('checkFinsh', {
                check_reas: this.check_reas,
                check_stat: this.isPassFlag,
                data: this.checkPopInfo,
            })
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/V3/Main/Check/comCheckPop.vue